import { http} from "../http-common";

const FetchAllHierarchy = query => {
  return http.get(`/hierarchyLevelConfig/list?pageNumber=${query.pageNumber}&size=${query.size}&cropYear=${query.cropYear}`);
};
const addLevel = data => {
  return http.post('/hierarchyLevelConfig',data);
};
const updateData = data => {
  return http.put('/hierarchyLevelConfig', data);
};
const deleteLevel = id => {
  return http.delete('/hierarchyLevelConfig/'+id);
};
const updateSequence = (data) => {
  return http.put(`/hierarchyLevelConfig/sequence?cropYear=${data.cropYear}&oldSequence=${data.old}&newSequence=${data.new}`);
};
const copyHierarchyLevel = (cropYear) => {
  return http.post(`/hierarchyLevelConfig/copy-hierarchy-level?cropYear=${cropYear}`);
};

const HierarchyService = {

  FetchAllHierarchy,
  addLevel,
  updateData,
  deleteLevel,
  updateSequence,
  copyHierarchyLevel

};

export default HierarchyService;

